<se-autocomplete-cell-editor-popup tabindex="0"
                                    [value]="value"
                                    [required]="required"
                                    (updatedValue)="setValue($event)"
                                    [items]="items">
</se-autocomplete-cell-editor-popup>
